import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/shadcn/utils';

const inputVariants = cva(
  cn(
    'border-input flex flex-row items-center gap-2 text-base',
    'transition-[color,box-shadow,border]',
    '[&>input]:placeholder:text-placeholder-grey [&>input]:placeholder:text-base [&>input]:placeholder:font-medium [&>input]:focus:outline-0',
    '[&>input]:file:text-foreground/50 [&>input]:file:mr-2 [&>input]:file:inline-flex [&>input]:file:text-sm [&>input]:file:font-medium',
    '[&>svg]:text-muted-foreground',
    'selection:bg-primary selection:text-primary-foreground',
  ),
  {
    variants: {
      variant: {
        outline: cn(
          'rounded-md',
          'has-focus:border-ring has-focus-visible:border-ring has-focus-visible:ring-ring/50 has-focus-visible:ring-[3px]',
          'has-aria-invalid:ring-destructive/20 has-aria-invalid:border-destructive dark:has-aria-invalid:ring-destructive/40 has-aria-invalid:border-1',
        ),
      },
      size: {
        default: 'px-2 py-1',
        sm: 'px-2 py-1 text-sm',
        lg: 'text-16 px-3 py-3',
        xl: 'px-3 py-2 text-xl',
      },
    },
    defaultVariants: {
      variant: 'outline',
      size: 'default',
    },
  },
);

function IconInput({
  className,
  variant,
  size,
  children,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof inputVariants>) {
  return (
    <div className={cn(inputVariants({ variant, size }), className)} {...props}>
      {children}
    </div>
  );
}

export { IconInput };
